import { render, staticRenderFns } from "./createTipoProtocolo.vue?vue&type=template&id=27a587e0&scoped=true&"
import script from "./createTipoProtocolo.vue?vue&type=script&lang=js&"
export * from "./createTipoProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./createTipoProtocolo.vue?vue&type=style&index=0&id=27a587e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a587e0",
  null
  
)

export default component.exports